export default __webpack_public_path__ + "static/media/icons-id-card-48-px.9387efb4.svg";